import StatusBoardComponent from '../components/dashboard/StatusBoard';

export default function StatusBoard() {
  return (
    <div id={'contents'}>
      <StatusBoardComponent />
    </div>
  );
}
